import { render } from "./SimpleNoteDetailSummaryCard.vue?vue&type=template&id=dea537c4&scoped=true"
import script from "./SimpleNoteDetailSummaryCard.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailSummaryCard.vue?vue&type=script&lang=js"

import "./SimpleNoteDetailSummaryCard.vue?vue&type=style&index=0&id=dea537c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea537c4"]])

export default __exports__